// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_hj-a";
export var fulfillmentFormRail = "_hj-9";
export var headerTitleRow = "_hj-c";
export var orderDetailsWrapper = "_hj-7";
export var orderLinkTrigger = "_hj-2";
export var paymentInformationGrid = "_hj-h";
export var paymentSummaryColumn = "_hj-i";
export var shipmentContainer = "_hj-b";
export var shipmentDetailsMainPane = "_hj-8";
export var shipmentNavigationCard = "_hj-5";
export var shipmentNavigationRail = "_hj-3";
export var shipmentNavigationRailHeader = "_hj-4";
export var shipmentSummaryFact = "_hj-e";
export var shipmentSummaryGrid = "_hj-d";
export var shipmentSummaryMetadataRow = "_hj-f";
export var shipmentSummaryTags = "_hj-g";
export var shipmentWorkspace = "_hj-0";
export var shipmentWorkspaceContent = "_hj-6";
export var shipmentWorkspaceHeader = "_hj-1";